import axiosInstance from "../Interceptors/ResponseInterceptor";

export const getAllCompany = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(`/api/company`);
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getLocationByCity:", error);
      reject(error);
    }
  });
};
